import { SortData, getSortParams } from '../ducks';
import { useSelector } from 'react-redux';

export const useGetSortParams = () => {
  const sortData: Partial<SortData> = useSelector(getSortParams);
  return { ...sortData };
};
